// External Dependencies
import { useMemo } from 'react';
import { EstimatesIndexResponse } from '@presto-assistant/api_types/api/admin/estimates';
import { GridColDef } from '@mui/x-data-grid-pro';

// Internal Dependencies
import { dateColumn, dateTimeColumn, currencyFromCentsColumn } from 'utils/lib/tableColumns';

export const useColumns = () => {
  return useMemo(() => {
    const columns: GridColDef<EstimatesIndexResponse['data'][number]>[] = [
      dateTimeColumn({
        field: 'createdAt',
        headerName: 'Created At',
      }),
      dateColumn({
        field: 'estimateDate',
        headerName: 'Estimate Date',
      }),
      {
        field: 'status',
        headerName: 'Status',
        type: 'singleSelect',
        valueOptions: [
          {
            label: 'Estimate Pending Review',
            value: 'Estimate Pending Review',
          },
          {
            label: 'Estimate Approved',
            value: 'Estimate Approved',
          },
          {
            label: 'Estimate Rejected',
            value: 'Estimate Rejected',
          },
          {
            label: 'Estimate Expired',
            value: 'Estimate Expired',
          },
          {
            label: 'PO Pending Review',
            value: 'PO Pending Review',
          },
          {
            label: 'PO Approved',
            value: 'PO Approved',
          },
          {
            label: 'PO Rejected',
            value: 'PO Rejected',
          },
          {
            label: 'Converted to Invoice',
            value: 'Converted to Invoice',
          },
        ],
      },
      {
        field: 'districtName',
        headerName: 'Admin Portal',
      },
      {
        field: 'estimateNumber',
        headerName: 'Estimate Number',
        type: 'number',
        valueFormatter: (params) => {
          return params.value;
        },
        width: 160,
      },
      currencyFromCentsColumn({
        field: 'totalInCents',
        headerName: 'Total',
      }),
      dateColumn({
        field: 'expirationDate',
        headerName: 'Expiration Date',
      }),
      dateTimeColumn({
        field: 'approvedAt',
        headerName: 'Approved At',
      }),
      dateTimeColumn({
        field: 'rejectedAt',
        headerName: 'Rejected At',
      }),
      {
        field: 'rejectedReason',
        filterable: false,
        headerName: 'Rejected Reason',
        sortable: false,
      },
    ] as GridColDef<EstimatesIndexResponse['data'][number]>[];

    return columns;
  }, []);
};
